import Helpers from '@helpers';
import * as React from 'react';
import OrderSummaryHelper from '../order-summary/order_summary';
import ShippingHelper from '../shipping-list/shipping_list';
import { Prop, State } from './model';
import './styles.css';

class Installment extends React.Component<Prop, State> {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    public componentDidMount() {
        const code = this.getCodeHiddenFieldValue();
        if (code) {
            this.validateInstallment(code);
            this.setState({
                enabled: true
            });
        }
        var input = document.getElementById('loan-code')
        input.addEventListener("keypress", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById('loan-btn').click();
            }
        })
    }

    public componentDidUpdate() {
        if (this.isInstallmentValid()) {
            OrderSummaryHelper.setInstallmentAmount(this.state.enabled?this.state.installment.amount:0);
            ShippingHelper.setInstallmentState(this.state.installment.amount && this.state.installment.amount > 0 && this.state.enabled);
            $('#hdfInstallmentCode').val(this.state.enabled ? this.state.installment.code:'');

        } else {
            OrderSummaryHelper.setInstallmentAmount(0);
            ShippingHelper.setInstallmentState(false);
            $('#hdfInstallmentCode').val('');
        }
    }

    public render() {
        return (
            <div className="w-100">
                <h4 className="order-page__header">
                    انتخاب شیوه پرداخت قسطی
                </h4>
                <div className='installment'>
                    <div className="d-flex align-items-center">
                        <label className="installment-select">
                            <input type='checkbox' id='installmentPayment' onChange={this.handleEnabled} checked={this.state.enabled}/>
                            خرید قسطی
                        </label>
                        <span className="hint">(چطور <a href='/installment' target="_blank">خرید اقساطی</a> داشته باشم؟)</span>
                    </div>

                    <div className="section-body" style={{ display: this.state.enabled ? 'flex' : 'none' }}>

                        <div className="installment-input-wrapper">
                            <div>
                                <p>کد خرید اقساطی خود را وارد نمایید.</p>
                                <div className={this.isInstallmentValidAndSame() ? 'fields-container success' : 'fields-container'}>
                                    <input type='text' id='loan-code' onChange={this.handleChange} value={this.state.inputValue} className="form-control" />

                                </div>
                                <div className='alert-box alert-error errors voucher-error'
                                    style={{ display: this.getErrorMessage() ? 'block' : 'none' }}>
                                    {this.getErrorMessage()}
                                </div>
                            </div>
                            
                        </div>                        
                        <button id="loan-btn" style={{ display: this.isInstallmentValidAndSame() ? 'none' : 'block' }} className='btn btn-red' onClick={this.submitInstallment}>
                             ثبت
                        </button>
                        <div className='installment-success'
                            style={{ display: this.isInstallmentValidAndSame() ? 'block' : 'none' }}>
                            <i className='fa fa-check' />
                                        کد شما با موفقیت ثبت شد
                        </div>
                    </div>
                    <span className="installment-announce" style={{ display: this.isInstallmentValidAndSame() ? 'block' : 'none' }}>
                        مبلغ <b>{Helpers.Utils.formatPrice(this.state.installment ? this.state.installment.amount : 0)}</b> از خرید شما به صورت اقساطی لحاظ می گردد.
                    </span>
                </div>
            </div>
        );
    }

    private handleChange = event => {
        const inputValue = event.target.value;
        this.setState({
            inputValue
        });
    }

    private handleEnabled = event => {
        const enabled = event.target.checked;
        this.setState({
            enabled
        });
    }

    private submitInstallment = e => {
        if (this.state.inputValue) {
            this.validateInstallment(this.state.inputValue);
        }

        e.preventDefault();
    }

    private validateInstallment = (code: string) => {
        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.validateInstallment(code).then(installment => {
            this.setState({
                installment
            });

            Helpers.LoadingHelper.hideLoading();
        });
    }

    private isInstallmentValid = (): boolean =>
        this.state.installment &&
        this.state.enabled &&
        !this.state.installment.errorMessage &&
        this.state.installment.amount > 0;

    private isInstallmentValidAndSame = (): boolean =>
        this.state.installment &&
        this.state.enabled &&
        !this.state.installment.errorMessage &&
        this.state.installment.amount > 0 &&
        this.state.inputValue===this.state.installment.code;

    private getErrorMessage = (): string => {
        if (this.state.installment &&
            this.state.enabled &&
            this.state.installment.errorMessage &&
            this.state.installment.errorMessage.length > 0) {
            return this.state.installment.errorMessage;
        }

        return null;
    }

    private getInitialState = (): State => ({
        installment: null,
        errorMessage: null,
        inputValue: $('#hdfInstallmentCode').val().toString(),
        enabled: false
    });

    private getCodeHiddenFieldValue = () => {
        const value = $('#hdfInstallmentCode').val().toString();
        return value.length > 0 ? value : null;
    }
}

Helpers.ReactHelper.createReactElement('Installment', Installment);
